module.exports = __webpack_public_path__ + "static/img/gymimg.936b998d.png";